import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import FastImageView from '../../components/FastImageView';
import colors from '../../theme/Colors';
import { isIOS, isPresent } from '../../utils/BooleanUtility';
import { useSelector } from 'react-redux';

export default function ChatTabIcon({ icon, imageStyle }) {
  const unreadChatCount = useSelector((state) => state?.UserAccountInfo?.unreadChatCount);
  const [unreadCount, setUnreadCount] = useState(unreadChatCount);

  useEffect(() => {
    setUnreadCount(unreadChatCount);
  }, [unreadChatCount]);

  const unreadCountMessage = unreadChatCount >= 20 ? '20+' : unreadChatCount;
  const containerStyle =
    unreadChatCount >= 20
      ? [styles.unreadMessagesCountContainer, { right: isIOS() ? 16 : 8 }]
      : styles.unreadMessagesCountContainer;
  return (
    <>
      <FastImageView source={icon} resizeMode={'contain'} style={imageStyle} />
      {isPresent(unreadCount) && unreadCount !== 0 && (
        <View style={containerStyle}>
          <Text style={styles.unreadMessagesCountText}>{unreadCountMessage}</Text>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  unreadMessagesCountContainer: {
    backgroundColor: '#1B1F6A',
    borderRadius: 12,
    paddingHorizontal: 4,
    paddingVertical: 0,
    position: 'absolute',
    right: isIOS() ? 16 : 16,
    top: 4,
  },
  unreadMessagesCountText: {
    color: colors.white,
    fontSize: 10,
    fontFamily: 'Roboto-Medium',
  },
});
